import ReferenceDetails from '@/components/ReferenceDetails'
import {
  shouldShowDecisionComments,
  shouldShowReferenceDetails,
} from '@/components/ReferenceDetails/utils'
import type { IncomeEmployerReference } from '@/types/Activity'

import { toReferee, toReferenceDetails } from './utils'

export interface Props {
  applicantName?: string
  employerReference: IncomeEmployerReference
  navigateToEmployerReferee: (id: string) => void
}

const EmployerReferenceDetails = ({
  employerReference,
  applicantName,
  navigateToEmployerReferee,
}: Props) => {
  const outcomeStatus = employerReference.outcome.status
  return (
    <ReferenceDetails
      referee={toReferee(employerReference)}
      refereeType="employer"
      applicantName={applicantName}
      navigateToReferee={navigateToEmployerReferee}
      referenceDetails={
        shouldShowReferenceDetails(outcomeStatus)
          ? toReferenceDetails(employerReference)
          : undefined
      }
      decisionComments={
        shouldShowDecisionComments(outcomeStatus)
          ? employerReference.outcome.comments
          : undefined
      }
      additionalContext={employerReference.additionalContext ?? undefined}
    />
  )
}

export default EmployerReferenceDetails
